<template>
  <div id="app">
    <div id="demo"></div>
  </div>
</template>

<script>
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
export default {
  name: "pdfBox",
  data() {
    return {
      pdfh5: null,
    };
  },
  mounted() {
    //实例化-1观展 2参展
    this.pdfh5 = new Pdfh5("#demo", {
      pdfurl: (this.$route.query.type == 2 ? "https://cdn.alighting.com/award/article/zhinan20250327.pdf" : "https://cdn.alighting.com/wxopen/cover/2025观展指南.png")
    });
    //监听完成事件
    this.pdfh5.on("complete", function(status, msg, time) {
      console.log(`状态：${status}，信息：${msg}，耗时：${time}毫秒，总页数：${this.totalNum}`);
    });
  }
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
}

html,
body,
#app {
  width: 100%;
  height: 100%;
}
</style>
